import type { HttpClient } from './http';
import type { UsageSummary } from './types';

export interface UsageApi {
  getSummary(params?: { year?: number; month?: number }): Promise<UsageSummary>;
}

export function createUsageApi(http: HttpClient): UsageApi {
  const base = '/usage';
  return {
    getSummary: (params = {}) => {
      const search = new URLSearchParams();
      if (typeof params.year === 'number')
        search.set('year', String(params.year));
      if (typeof params.month === 'number')
        search.set('month', String(params.month));
      const query = search.toString();
      return http.get<UsageSummary>(`${base}${query ? `?${query}` : ''}`);
    },
  };
}
